import { BrowserRouter } from 'react-router-dom'
import Rotas from './routes/routes'

function App() {
  return (
    <BrowserRouter>
      <Rotas />
    </BrowserRouter>
  )
}

export default App
